var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex"},_vm._l((_vm.fields),function(field){return _c('div',{key:field.key,staticClass:"text-center field-type col d-flex flex-column justify-content-center",class:{
      selected: field.key === _vm.selected,
      disabled: _vm.disabled,
    },on:{"click":function($event){_vm.disabled ? null : _vm.$emit('update:selected', field.key)}}},[_c('i',{class:field.icon}),_c('div',[_vm._v(" "+_vm._s(field.text)+" ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }